import { render, staticRenderFns } from "./overallTrendsCard.vue?vue&type=template&id=06c964df&scoped=true"
import script from "./overallTrendsCard.vue?vue&type=script&lang=ts"
export * from "./overallTrendsCard.vue?vue&type=script&lang=ts"
import style0 from "./overallTrendsCard.vue?vue&type=style&index=0&id=06c964df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c964df",
  null
  
)

export default component.exports